import { render, staticRenderFns } from "./acc_paw.vue?vue&type=template&id=0d1285b2&"
import script from "./acc_paw.vue?vue&type=script&lang=js&"
export * from "./acc_paw.vue?vue&type=script&lang=js&"
import style0 from "./acc_paw.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports